<template>
  <BaseModal :isShow="isShow" @close="emit('close')">
    <div class="flex flex-col w-full p-6 gap-4 text-justify laptop:text-right">
      <div class="text-base laptop:text-xl font-bold">
        قوانین و شرایط استفاده از خدمات {{ title }}
      </div>
      <div class="text-xs laptop:text-base">
        کاربران جهت استفاده از خدمات {{ title }}، موظف به پذیرش و رعایت قوانین
        زیر می‌باشند:
      </div>
      <ul class="list-decimal ms-4 text-xs laptop:text-base">
        <li v-for="term in terms" :key="term.id" v-text="term.text" />
      </ul>
      <div class="flex justify-end">
        <BaseButton
          @click="acceptClicked"
          isLean
          size="2xl"
          text="قبول قوانین و شرایط"
        />
      </div>
    </div>
  </BaseModal>
</template>

<script setup>
const props = defineProps({
  isShow: Boolean,
  title: {
    type: String,
    default: "نواتل",
  },
});

const emit = defineEmits(["accept", "close"]);

const terms = [
  {
    id: 0,
    text: "مسئولیت صحت اطلاعات وارد شده، برعهده کاربر بوده و در صورت ارائه اطلاعات غلط، پیامدهای احتمالی متوجه وی خواهد بود.",
  },
  {
    id: 1,
    text: `امکان واگذاری سرویس های ${props.title} تنها برای افراد بالای 18 سال امکان پذیر است.`,
  },
  {
    id: 2,
    text: `استفاده از سرویس‌های ${props.title} تنها متعلق به مشتری است و در صورتی که مشتری، آن را به هر نحوی در اختیار دیگران قرار دهد، پیامدهایی مانند قطع ناگهانی و بدون بازپرداخت خدمات را در پی خواهد داشت.`,
  },
  {
    id: 3,
    text: "پس از تکمیل فرآیند خرید، مبلغ مالیات دریافتی از کاربر  تماماً به اداره مالیات بر ارزش افزوده پرداخت می‌شود.",
  },
  {
    id: 4,
    text: `پس از تکمیل فرآیند خرید، مشتری متعهد می شود که جهت احراز هویت، عقد قرارداد و تحویل سرویس، همکاری های لازم را با کارشناسان ${props.title} به عمل خواهد آورد. `,
  },
];

const acceptClicked = () => {
  emit("accept");
  emit("close");
};
</script>
